const swal = require('sweetalert2');

function warning(
  text,
  title = 'Are you sure?',
  confirmButtonText = 'Yes',
  showCancelButton = true,
  buttonsStyling = false
) {
  return swal
    .fire({
      title: title,
      html: text,
      type: 'warning',
      width: 550,
      padding: '3em',
      showCancelButton: showCancelButton,
      confirmButtonClass: 'btn btn-lg btn-primary',
      cancelButtonClass: 'btn btn-lg btn-primary preview',
      confirmButtonText: confirmButtonText,
      buttonsStyling: buttonsStyling,
    })
    .then(result => {
      return result.value === true;
    });
}

export const confirmationHelper = {
  warning,
};
